export default function CloseSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      <path d="M11 0.7H13V23.3H11z" transform="rotate(-45.001 12 12)"></path>
      <path d="M0.7 11H23.3V13H0.7z" transform="rotate(-45.001 12 12)"></path>
    </svg>
  );
}
